import React, { useEffect, useState } from 'react'
import { CheckboxContainer, ChecklistCard, HiddenCheckbox, Label, ScrollableContainer, StyledCheckbox } from './style'

export interface WhichFieldsToShowType {
  field: string
  fieldName: string
  checked: boolean
}

export interface FieldsManagerType {
  tableSection: 'companies' | 'users' | 'certificates' | 'stock' | 'movement'
  whichFieldsToShow: WhichFieldsToShowType[]
}

interface PropsType {
  fields: FieldsManagerType
  setFields: React.Dispatch<React.SetStateAction<FieldsManagerType>>
  dropdownOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const FieldsManager: React.FC<PropsType> = ({ fields, setFields, dropdownOpen }) => {
  const dropdownRef = React.useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        dropdownOpen(false)
      }
    }
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)}
  }, [])
  
  const handleCheckboxChange = (itemIndex: number) => {
    setFields(prev => ({
      ...prev,
      whichFieldsToShow: prev.whichFieldsToShow.map((field, index) =>(
        index === itemIndex ? { ...field, checked: !field.checked } : field
      ))
    }))
  }
  
  return(
    <ChecklistCard ref={dropdownRef}>
      <ScrollableContainer>
        {fields.whichFieldsToShow.map((field, index) => (
          <CheckboxContainer key={index}>
            <HiddenCheckbox
              checked={field.checked}
              onChange={() => handleCheckboxChange(index)}
            />
            <StyledCheckbox checked={field.checked} onClick={() => handleCheckboxChange(index)} />
            <Label onClick={() => handleCheckboxChange(index)}>
              {field.fieldName}
            </Label>
          </CheckboxContainer>
        ))}
      </ScrollableContainer>
    </ChecklistCard>
  )
}

export default FieldsManager